(function ($) {
    $(document).ready(function () {
        //only run for logged in users on portal archive pages
        if (
            $("body").is(".logged-in.page-template-board-portal-archive-page")
        ) {
            //pagination links click handler
            $(".document-pagination-container a.page-numbers").click(function (
                e
            ) {
                e.preventDefault();

                let clickedPaginationLink = $(e.target);
                let clickedPageNumber = clickedPaginationLink.data("page");
                let currentSection = $(e.target).closest(
                    ".documents-list-section"
                );
                let currentDocumentWrapper = currentSection
                    .find(".documents-container")
                    .first();

                let documentCategoryID = currentSection.data("categoty-id");
                let postsPerPage = currentSection.data("posts-per-page");
                let currentPageNumber =
                    currentSection.attr("data-current-page");

                //only proceed if the clicked link is not the current page
                if (clickedPageNumber != currentPageNumber) {
                    //add a loading class to the results container
                    currentDocumentWrapper.addClass("loading");

                    //ajax request to get requested documents
                    var data = {
                        category_id: documentCategoryID,
                        posts_per_page: postsPerPage,
                        requsted_page: clickedPageNumber,
                        action: "get_portal_documents",
                    };

                    jQuery.post(
                        "/wp-admin/admin-ajax.php",
                        data,
                        function (response) {
                            //replace the documents on the page
                            currentDocumentWrapper.html(response);

                            //remove the loading class
                            currentDocumentWrapper.removeClass("loading");

                            // update the data attribute of the container
                            currentSection.attr(
                                "data-current-page",
                                clickedPageNumber
                            );

                            //set the 'current' class on the right pagination link
                            currentSection
                                .find(".page-numbers.current")
                                .removeClass("current");
                            clickedPaginationLink.addClass("current");
                        }
                    );
                }
            });
        }

        //show and hide the portal search form when the search button in the portal header is clicked
        $("#portal-header-search-btn").click(function () {
            $("#portal-search-container-desktop").slideToggle();
        });

        //only run for logged in users on search result page
        if ($("body").is(".logged-in.search")) {
            //load more button click handler
            $("#board-portal-load-more-btn").click(function (e) {
                let loadMoreBtn = $(e.target);
                // Save the button's text so we can restore it when removing the loading state
                let originalButtonText = loadMoreBtn.html();
                // change the button text and disable it while loading
                loadMoreBtn.attr("disabled", true).text("Loading...");

                let searchContainer = loadMoreBtn.closest(
                    ".portal-search-container"
                );
                let resultsColumn = searchContainer
                    .find(".results-container")
                    .first();

                let currentPageNumber = Number(
                    searchContainer.attr("data-current-page")
                );
                let postsPerPage = searchContainer.attr("data-posts-per-page");
                let maxPageNumber = searchContainer.attr("data-max-page");
                let searchTerm = searchContainer.attr("data-search-term");

                //only proceed if there are more pages to load
                if (maxPageNumber > currentPageNumber) {
                    //add a loading class to the results container
                    resultsColumn.addClass("loading");

                    //ajax request to load more documents
                    var data = {
                        posts_per_page: postsPerPage,
                        requsted_page: currentPageNumber + 1,
                        max_page_number: maxPageNumber,
                        search_term: searchTerm,
                        action: "load_more_portal_documents",
                    };

                    jQuery.post(
                        "/wp-admin/admin-ajax.php",
                        data,
                        function (response) {
                            // update the load more button text and remove disabled state
                            loadMoreBtn
                                .attr("disabled", false)
                                .html(originalButtonText);

                            // append the documents on the page
                            resultsColumn.append(response);

                            //remove the loading class
                            resultsColumn.removeClass("loading");

                            let loadedPageNumber = currentPageNumber + 1;
                            // update the data attribute of the container
                            searchContainer.attr(
                                "data-current-page",
                                loadedPageNumber
                            );

                            //hide the load more button if needed
                            if (loadedPageNumber == maxPageNumber) {
                                loadMoreBtn
                                    .closest(".portal-load-more-row")
                                    .slideUp();
                            }
                        }
                    );
                }
            });
        }
    });
})(jQuery);
